webpackJsonp([81129344858808],{

/***/ 1838:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"LocationAttribute","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"customAttribute","type":{"kind":"OBJECT","name":"CustomLocationAttribute","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"value","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-location-attribute-fdaf763b36b1f8052a52.js